import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import {
  GetStudyLines,
  GetStudyLinesWithSupervisors,
} from '../helper/apiHelper';

export const useStudyLines = () => {
  return useQuery({
    queryKey: QUERY_KEYS.STUDY_LINES,
    queryFn: () => GetStudyLines(),
  });
};

export const useStudyLinesWithSupervisors = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.STUDY_LINES_WITH_SUPERVISORS],
    queryFn: GetStudyLinesWithSupervisors,
  });
};
